export const VehicleTypes = [
  { id: 1, name: "CAR" },
  { id: 2, name: "MOTORCYCLE" },
  { id: 3, name: "TRUCK" },
  { id: 4, name: "RV" }
]

export const InspectorStatusData = [
  { id: "", name: "All", displayName: "All" },
  { id: 1, name: "Applicant", displayName: "Applicant" },
  { id: 2, name: "AwaitingContract", displayName: "Awaiting Contract" },
  { id: 3, name: "AwaitingApprove", displayName: "Awaiting Approve" },
  { id: 4, name: "Approved", displayName: "Approved" },
  // { id: 5, name: "Warned", displayName: "Warned" },
  { id: 6, name: "Rejected", displayName: "Rejected" },
  { id: 7, name: "Suspended", displayName: "Suspended" }
]

export const QuotationStatusData = [
  { id: "0", name: "All", displayName: "All", sorting: "desc" },
  { id: "1", name: "AwaitingInspector", displayName: "Awaiting Inspector", sorting: "asc" },
  { id: "2", name: "AwaitingInspection", displayName: "Awaiting Inspection", sorting: "asc" },
  { id: "3", name: "AwaitingApproval", displayName: "Awaiting Approval", sorting: "asc" },
  { id: "4", name: "Completed", displayName: "Completed", sorting: "desc" },
  { id: "5", name: "Cancelled", displayName: "Canceled", sorting: "desc" },
]

export const OrderTransactionData = [
  { id: "7", name: "Completed", displayName: "Completed" },
  { id: "100", name: "Abandoned", displayName: "Abandoned" },
]

export const QuotationStepData = [
  { id: "1", name: "VehicleType", displayName: "Vehicle Type" },
  { id: "2", name: "VehicleInfo", displayName: "Vehicle Info" },
  { id: "3", name: "SellerInfo", displayName: "Seller Info" },
  { id: "4", name: "RequesterInfo", displayName: "Requester Info" },
  { id: "5", name: "Payment", displayName: "Payment" },
  { id: "6", name: "Review", displayName: "Review" },
]

export const PaymentStatusData = [
  { id: "0", name: "None", displayName: "None" },
  { id: "4", name: "Processing", displayName: "Processing" },
  { id: "5", name: "Succeeded", displayName: "Succeeded" },
  { id: "6", name: "Canceled", displayName: "Canceled" },
  { id: "7", name: "Failed", displayName: "Failed" },
]

export const CoversionMethodTypeData = [
  { id: "1", name: "Transfer", displayName: "Transfer" },
  { id: "2", name: "PaymentId", displayName: "Payment Id" },
  { id: "3", name: "Free", displayName: "Free" },
  { id: "4", name: "Other", displayName: "Other" }
]

export const Roles = {
  Admin: 'Admin',
  EmployeeAdmin: 'EmployeeAdmin',
  Employee: 'Employee',
  VehicleInspector: 'VehicleInspector',
  Customer: 'Customer'
}

export const Agreements = {
  IndependentContractor: 'IndependentContractor',
  InspectorAccountAccess: 'InspectorAccountAccess',
  InspectorApplication: 'InspectorApplication',
  InspectorPrivacyPolicy: 'InspectorPrivacyPolicy'
}

export const DashboardMessage = {
  AccountSuspended: { text: "Your account has been suspended. If you believe this is a mistake, please contact us at support@inspectiver.com", className: "alert alert-danger" },
  AccountWarning: { className: "alert alert-warning", badge: { text: "Warning", className: "badge badge-dark me-2" } },
  BankingInformationMissing: { text: "Please enter your banking information to ensure timely payments", navigation: '/profile', className: "alert alert-secondary" },
  ProfileImageMissing: { text: "Please upload a profile picture to your account", navigation: '/profile', className: "alert alert-secondary" },
  MissingSSN: { text: "We are required to verify your identity and use your Social Security Number (SSN) for tax reporting purposes. Please provide it", navigation: '/settings/ssn', className: "alert alert-warning" }
}

export const InspectionSection = {
  VehicleInfo: 'VehicleInfo',
  Exterior: 'Exterior',
  Interior: 'Interior',
  Mechanical: 'Mechanical',
  Tires: 'Tires',
  RoadTest: 'RoadTest',
  Summary: 'Summary',
  Motorcycle: 'Motorcycle',
  RVExtra: 'RVExtra'
}

export const SampleReportData = {
  HondaCRV: { id: "a698ce46-a965-4f28-a88a-f58c4f052988", param: "honda-crv-2023" },
  BMW428: { id: "a7bf347a-0503-4384-b649-9d7749dfe620", param: "bmw-428-2014" }
}

export const InspectionAmount = {
  Car: "149.00",
  Motorcycle: "149.00",
  Commercial: "189.00",
  RV: "249.00"
}


export const makeInitialData = [
  { name: 'HYUNDAI', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d046a' },
  { name: 'FORD', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d047c' },
];

export const modelInitialData = [
  { name: 'I20', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d045a', makeId: 'ec00ce83-ac5b-0ddd-0167-3a00a35d046a' },
  { name: 'MUSTANG', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d046c', makeId: 'ec00ce83-ac5b-0ddd-0167-3a00a35d047c' }
];

export const categoryInitialData = [
  { name: 'Cat A', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d015a' },
  { name: 'Cat B', id: 'ec00ce83-ac5b-0ddd-0167-3a00a35d016c' }
];

export const Trainings = [
  {
    id: 1,
    image: '',
    description: 'Essential Tools for Inspections',
    path: 'tools'
  },
  {
    id: 2,
    image: '',
    description: 'How to Perform Exterior Inspection',
    path: 'exterior'
  },
  {
    id: 3,
    image: '',
    description: 'How to Perform Interior Inspection',
    path: 'interior'
  },
  {
    id: 4,
    image: '',
    description: 'How to Perform Mechanical Inspection',
    path: 'mechanical'
  },
  {
    id: 5,
    image: '',
    description: 'How to Inspect Tires',
    path: 'tires'
  },
  {
    id: 6,
    image: '',
    description: 'How to Perform a Road Test',
    path: 'roadtest'
  },
  {
    id: 7,
    image: '',
    description: 'How to Write a Summary About Inspection',
    path: 'summary'
  },
]

export const TrainingList = [
  {
    id: "tools",
    image: 'assets/images/blog/01.jpg',
    date: '15 Sep',
    category: 'Training',
    title: 'Critical Tools for Inspections',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'In our commitment to excellence, we require you bring essential tools listed below for inspections. Here is a list of the key tools you will need:',
    content: ['-Flashlight', '-Basic Hand Tools like screwdrivers, pliers, wrenches etc.', '-ODB2 Scanner', '-Multimeter', '-Paint Thickness Gauge', '-Tire Tread Gauge', '-Pointer tool (anything) for showing the area need attention in picture', '-Mirror on a stick for hard to reach areas', '-Personal Safety Gear', '-If available; Jack, Jack Stands, Car Ramp or Lift', 'These tools, coupled with your expertise, will uphold our inspection standards and ensure precise evaluations for our clients.'],
    nextId: 'exterior'
  },
  {
    index: 2,
    id: "exterior",
    image: 'assets/images/blog/02.jpg',
    date: '15 Sep',
    category: 'Software',
    title: 'How to perform exterior inspection',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'In this chapter, we\'ll guide you through a systematic, time-efficient method for conducting precise exterior inspections. As you follow our detailed report creation page, each step is designed to ensure accuracy while honing your time management skills. Thoroughly grasping and internalizing this process is imperative for conducting flawless inspections. Additionally, don\'t hesitate to take as many pictures as necessary to showcase the vehicle\'s exterior condition.',
    content: [<b>1. Visual Assessment</b>, 'Begin your exterior inspection by conducting a comprehensive visual assessment. Start with the body panels, scrutinizing for dents, scratches, or any irregularities in the paint. Check the alignment of panels and gaps between them for consistency, as misalignments could indicate previous repairs. Inspect the exterior lights, glass, and trim for damages or signs of wear.', <b>2. Utilizing a Paint Thickness Gauge</b>, 'The paint thickness gauge stands as an invaluable tool in our inspection process, enabling us to precisely measure paint layers and uncover concealed details. As you employ this gauge, ensure thorough measurements across critical sections like fenders, doors, hood, roof, and trunk. Document variations in paint depth meticulously, capturing images to highlight any anomalies that could hint at prior accidents or repairs. It is noteworthy that vehicles typically have an original paint thickness between 90-110 nanometers upon manufacturing. Any deviation, whether consistent or irregular, demands detailed documentation through pictures and comprehensive notes in the report.', 'Understanding the readings obtained from the paint thickness gauge is pivotal. A higher reading than the standard thickness in specific areas might indicate additional paint layers due to past refinishing. Conversely, significantly low readings might signal areas where the original paint has been sanded or repainted, indicating potential cover-ups or repairs.', <b>3. Documenting Findings</b>, 'Accurate documentation is crucial for inspection reports. Record your observations meticulously, noting paint gauge measurements alongside visual assessments. Take photographs to supplement your findings, highlighting areas with irregular paint thickness or visible damages. This documentation serves as essential evidence for clients and aids in decision-making during vehicle evaluations.', <b>4.Final Assessment</b>, 'Conclude your exterior inspection by reviewing your gathered data and observations. Consider the overall condition of the exterior, taking into account both visual cues and paint gauge readings. Summarize your findings and comments in a clear and concise manner in your report, emphasizing any significant findings or areas of concern discovered during the inspection.'],
    nextId: 'interior'
  },
  {
    id: "interior",
    image: 'assets/images/blog/03.jpg',
    date: '15 Sep',
    category: 'Landing',
    title: 'How to perform interior inspection',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'This guide helps you inspect vehicle interiors thoroughly and quickly. Each step is designed for accuracy and saving time, ensuring flawless evaluations. Remember to carefully note down everything you find during the inspection—good or needing attention. Take detailed notes, pictures, and descriptions to support your evaluation.',
    content: [<b>1.Steering Wheel, Horn, Seats, Sun Visors</b>, 'Begin by examining the steering wheel for any signs of wear, tear, or damage. Ensure the horn functions properly, seats are intact, and sun visors operate smoothly without impairment.', <b>2.Headliner, Inner Door Panels, Interior Trim</b>, 'Check the headliner for tears, stains, or any signs of replacement. Inspect inner door panels meticulously, ensuring functionality and absence of damage, including any misalignments or signs of recent replacement. Scrutinize the interior trim thoroughly for loose or damaged parts, and observe for any inconsistencies in alignment or indications of alterations.', <b>3.Interior Lights, Power Locks, Window Switches, Window Functioning</b>, 'Test all interior lights, power locks, window switches, and verify the smooth functioning of all windows.', '4.Trunk, Hood, Fuel Door, Sunroof, Convertible Actuators', 'Assess the functionality of the trunk, hood, fuel door, sunroof (if applicable), and any convertible mechanisms.', <b>5.Dash, Dash Lights, Dash Warnings, Dash Gauges</b>, 'Examine the dashboard for scratches or cracks, ensure all dash lights are operational, and pay attention to any warning indicators or irregularities in dash gauges.', <b>6.Center Console, Cupholders, Radio, Navigation</b>, 'Inspect the center console for functionality, assess cupholder conditions, test the radio and navigation systems for proper operation.', <b>7.Airbags, Seat Belts and Other Safety Devices</b>, 'Confirm the airbags\' presence and assess the condition of seat belts, ensuring they retract properly and show no signs of damage.', <b>8.AC, Heater, Rear Defroster, Blower Motor, Seat Heaters</b>, 'Test the air conditioning and heating systems, ensuring they function in accordance with specified standards. Verify the rear defroster, blower motor, and seat heaters (if applicable) for proper operation.', <b>9.Carpet, Floor Mats</b>, 'Inspect the carpet for stains or damage, and check the condition of floor mats for wear or displacement.', <b>10.Cigarette Use or Any Odors</b>, 'Document any evidence of cigarette use, such as burns or odor, as this can impact the vehicle\'s condition.'],
    nextId: 'mechanical'
  },
  {
    id: "mechanical",
    image: 'assets/images/blog/04.jpg',
    date: '15 Sep',
    category: 'Landing',
    title: 'How to perform mechanical inspection',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'This guide is your essential tool for conducting thorough and efficient mechanical inspections. Remember to carefully note down every detail observed during the mechanical inspection whether it\'s positive or requires attention. Detailed notes, clear photographs, and comprehensive descriptions will strengthen and support evaluation of the vehicle\'s mechanical condition.',
    content: [<b>1.Key FOB, Computer Diagnosis / OBD2</b>, 'Begin by testing the functionality of the Key FOB and perform a comprehensive Computer Diagnosis using OBD2 equipment to check for any stored fault codes or system issues.', <b>2.Battery Condition, Charging System, Alternator, Starter</b>, 'Assess the battery\'s condition, including its charge and overall health. Evaluate the charging system, alternator, and starter for proper operation and any signs of wear or malfunction.', <b>3.Belts, Hoses, Air Filter</b>, 'Inspect the condition of belts for wear or damage, check hoses for leaks or signs of aging, and evaluate the air filter for cleanliness and effectiveness.', <b>4.Cooling System (Fan, Radiator, Coolant)</b>, 'Examine the cooling fan\'s functionality, check the radiator for leaks or damage, and inspect the entire coolant system for any signs of leaks or deficiencies.', <b>5.Power Steering System and Fluid, Power Steering Leaks</b>, 'Evaluate the power steering system\'s functionality, check the fluid level, and look for any potential leaks in the system.', <b>6.Engine Block, Oil, Engine Fluid Leaks</b>, 'Inspect the engine block for any visible issues, check the oil level and quality, and identify any potential leaks in the engine compartment.', <b>7.Transmission System and Fluid, Transmission Fluid Leaks</b>, 'Assess the transmission system\'s performance, check the fluid level and condition, and inspect for any leaks in the transmission system.', <b>8.Brake System, Pads, Brake Fluid Leaks</b>, 'Evaluate the brake system\'s effectiveness, including the condition of brake pads and checking for any leaks in the brake fluid system.', <b>9.Differential System, Differential Fluid Leaks</b>, 'Inspect the differential system\'s functionality and check for any leaks in the differential fluid.', <b>10.Catalytic Converter, Muffler System</b>, 'Examine the condition of the catalytic converter and muffler system, ensuring proper operation and absence of damage or leaks.', <b>11.CV Joints, Axles, Shocks, Struts, Bushings, Ball Joints, Rods, Arms</b>, 'Assess the condition of CV joints, axles, shocks, struts, and various suspension components, checking for wear, damage, or any issues affecting performance.', <b>12.Undercarriage Condition</b>, 'Conduct a thorough inspection of the undercarriage, checking for any signs of damage, rust, or potential concerns affecting the vehicle\'s integrity.'],
    nextId: 'tires'
  },
  {
    id: "tires",
    image: 'assets/images/blog/05.jpg',
    date: '15 Sep',
    category: 'Landing',
    title: 'How to check tires',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'This guide is your essential tool for conducting thorough and efficient tire inspections. Remember to carefully note down every detail observed during the tire inspection, whether it\'s positive or requires attention. Detailed notes, clear photographs, and comprehensive descriptions will strengthen and support the evaluation of the tires\' condition.',
    content: [<b>1.Tire Brand and Size</b>, 'Begin by identifying the tire brand and confirming it matches the specified size for the vehicle. Ensure the tires are appropriate and in line with the manufacturer\'s recommendations.', <b>2.Tire Tread Depth</b>, 'Measure the tire tread depth using a tread depth gauge at multiple points across the tire.', <b>3.Tire and Wheel Condition</b>, 'Inspect the tires and wheels thoroughly for any signs of damage, wear, bulges, cracks, or uneven wear patterns. Check for any embedded objects or irregularities that might compromise safety or performance.', <b>4.Spare Tire</b>, 'Evaluate the condition of the spare tire. Ensure it matches the vehicle\'s specifications, has proper inflation, and exhibits no signs of damage or wear that could impede its functionality in an emergency situation.', <b>5.Spare Tire Set</b>, ' If applicable, verify the completeness and condition of the spare tire set, including any tools or equipment required for changing a tire.'],
    nextId: 'roadtest'
  },
  {
    id: "roadtest",
    image: 'assets/images/blog/06.jpg',
    date: '15 Sep',
    category: 'Landing',
    title: 'How to do road test',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'This guide is your essential tool for conducting thorough and efficient road tests. Before proceeding, kindly request permission from the seller or owner to perform the road test. Remember to carefully note down every detail observed during the road test, whether it\'s positive or requires attention. Detailed notes and comprehensive descriptions will strengthen and support the evaluation of the vehicle\'s performance during the road test.',
    content: [<b>1.Engine Starting Performance</b>, 'Assess the engine\'s starting behavior, noting any irregularities or delays.', <b>2.Wheel Bearing, Steering, Suspension Performance</b>, 'Evaluate the performance of wheel bearings, steering responsiveness, and suspension behavior, noting any vibrations, noise, or handling issues.', <b>3.Transmission, Differential, Transfer Case Performance</b>, 'Test the transmission, differential, and transfer case functionality, observing shifts, noises, or any anomalies during acceleration or deceleration.', <b>4.Braking Performance</b>, 'Assess the effectiveness of the braking system, checking for responsiveness, noise, or any irregularities during braking.', <b>5.Interior Noise Performance</b>, 'Evaluate the interior for any unusual noises, rattles, or isolation issues during different driving conditions.', <b>6.Overall Engine Performance</b>, 'Monitor the overall engine performance, noting any fluctuations or concerns with power delivery.', <b>7.Automatic Start-Stop, Cruise Control</b>, 'Test the functionality of automatic start-stop systems and cruise control.', <b>8.Blind Spot Detection, Lane Assist, Hill Start Assist,Back-Up Camera, Parking Assist</b>, 'Verify the proper operation of these driver-assist features if equipped, noting any malfunctions or irregularities, evaluate the condition and clarity of the back-up camera', <b>9.Auto Pilot Assist</b>, 'Test the functionality of auto pilot or similar advanced driver-assist systems.'],
    nextId: 'summary'
  },
  {
    id: "summary",
    image: 'assets/images/blog/07.jpg',
    date: '15 Sep',
    category: 'Landing',
    title: 'How to write a summary',
    author: 'Admin',
    views: 275,
    comments: 300,
    subHeader: 'After the inspection, please provide a detailed summary of the vehicle\'s condition. We\'d appreciate a breakdown of your inspection process, starting from how you initiated the assessment and progressing through the inspection stages. Please include specifics about the steps taken during the examination of the exterior and interior conditions, assessment of mechanical components, evaluation of tire status, and details regarding the car\'s performance during the test drive.',
    content: ['Our aim is to provide a comprehensive report that not only highlights the vehicle\'s condition but also outlines the sequence of your inspection. This timeline or sequence will provide customers with a clear understanding of the inspection process and its findings. Your detailed report will serve as an essential tool for customers, aiding them in making informed decisions about the vehicle.'],
    nextId: ''
  },
];
